import { render, staticRenderFns } from "./menu-button.vue?vue&type=template&id=30111c13&scoped=true&"
import script from "./menu-button.vue?vue&type=script&lang=js&"
export * from "./menu-button.vue?vue&type=script&lang=js&"
import style0 from "./menu-button.vue?vue&type=style&index=0&id=30111c13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30111c13",
  null
  
)

export default component.exports